import { Primitive } from "src/types/primitive";
import { FormMultiSelectField, FormMultiSelectFieldProps } from "./FormMultiSelectField";

export interface FormSerializedMultiSelectFieldProps<
	TFieldValues extends object,
	Key extends Primitive,
> extends FormMultiSelectFieldProps<TFieldValues, Key> {}

export const FormSerializedMultiSelectField = <TFieldValues extends object, Key extends Primitive>(
	props: FormSerializedMultiSelectFieldProps<TFieldValues, Key>,
) => {
	return (
		<FormMultiSelectField
			{...props}
			encodeValue={(keys: Key[]) => JSON.stringify(keys)}
			decodeValue={(value: string | undefined) => {
				if (value === undefined) return [];
				return JSON.parse(value) as Key[];
			}}
		/>
	);
};
